module.exports = __webpack_public_path__ + "img/horn2.1bd03a69.png";